const isTenaStore = document.body.classList.contains('tena-store');
const {
  byob_tier1_qty,
  byob_tier2_qty,
  byob_tier3_qty,
  byob_tier1_discount,
  byob_tier2_discount,
  byob_tier3_discount
} = theme.settings;

const discounts = {
  [byob_tier1_qty]: byob_tier1_discount,
  [byob_tier2_qty]: byob_tier2_discount,
  [byob_tier3_qty]: byob_tier3_discount
};

let bodyHandlerTimeout = null;
function setBodyPaddingHandler() {
  clearTimeout(bodyHandlerTimeout);

  bodyHandlerTimeout = setTimeout(() => {
    window.innerWidth <= 768 ?
      document.body.style.paddingBottom = '60px' :
      document.body.style.paddingBottom = '0px';
  }, 500)
}

document.body.addEventListener('click', (e) => {
  const byobWidget = document.querySelector('.byob__widget');

  if (!e.target.closest('.byob__widget')) {
    document.body.classList.remove('overflow');
    byobWidget.classList.remove('is--open');
  }

  if (e.target.closest('.byob__widget-toggle') && window.innerWidth <= 768) {
    document.body.classList.toggle('overflow');
    byobWidget.classList.toggle('is--open');
  }

  if (e.target.closest('.byob__item-remove')) {
    bundleItemsHandler(e.target.closest('.byob__item-remove').dataset.uniqId, 'REMOVE');
    setMaxHeightHandler();
  }

  if (e.target.closest('.byobbtn')) {
    const targetElement = e.target.closest('.byobbtn');

    bundleListHandler({
      id: targetElement.dataset.variantId,
      image: targetElement.dataset.variantImage,
      price: targetElement.dataset.price,
      productTitle: targetElement.dataset.eventLabel,
      colorTitle: targetElement.dataset.colorName,
      sizeTitle: targetElement.dataset.sizeName
    })
    setMaxHeightHandler();
  }

  if (e.target.closest('.byob__widget-button')) {
    addToCartHandler();
  }
});

// We use setTimeout to call this function only once
let maxHeightHandlerTimeout;
const maxPerViewItems = 7;
function setMaxHeightHandler() {
  clearTimeout(maxHeightHandlerTimeout);
  maxHeightHandlerTimeout = setTimeout(() => {
    const byobItems = document.querySelectorAll('.byob__widget-list .byob__item');
    const byobList = document.querySelector('.byob__widget-list');
    if (byobItems.length > maxPerViewItems) {
      const firstElements = Array.from(byobItems).slice(0, maxPerViewItems);

      let totalHeight = 0;

      for (let i = 0; i < maxPerViewItems; i++) {
        totalHeight += firstElements[i].offsetHeight + 8;
      }
      byobList.style.maxHeight = `${totalHeight + 15}px`;
    } else {
      byobList.style.maxHeight = `initial`;
    }
  }, 300)
}

document.addEventListener('DOMContentLoaded', setBodyPaddingHandler);
window.addEventListener('resize', () => {
  setMaxHeightHandler();
  setBodyPaddingHandler();
});
window.addEventListener('orientationchange', () => {
  setBodyPaddingHandler();
  setMaxHeightHandler();
});

let addedBundleItems = [];

function moneyFormatHandler(money) {
  return `${productMoneySymbol}${(money / 100).toFixed(2)}`;
}

function setlocalStorageHandler() {
  localStorage.setItem('byob_items', JSON.stringify(addedBundleItems));
}

function getLocalStorageHandler(isAjaxRender) {
  const oldBundleItems = JSON.parse(localStorage.getItem('byob_items'));
  if (oldBundleItems) {
    oldBundleItems.forEach(byobItems => {
      const { id, image, price, productTitle, colorTitle, sizeTitle, uniqId } = byobItems;
      bundleListHandler({ id, image, price, productTitle, colorTitle, sizeTitle, uniqId }, true, isAjaxRender)
    });
  }

  const fetchedCount = Array.isArray(oldBundleItems) ? oldBundleItems.length : 0;
  progressbarMessageHandler(fetchedCount);
  progressBarHandler(fetchedCount);

  setMaxHeightHandler();
}
getLocalStorageHandler();
// We need this to render content after filering
window.byobGlobalHandler = getLocalStorageHandler;

function discountsHandler() {
  const byobItemsQuantity = addedBundleItems.length;
  let lastDiscountKey = null;

  const keys = Object.keys(discounts);
  for (const key of keys) {
    if (byobItemsQuantity >= key) lastDiscountKey = key;
  }

  addedBundleItems.forEach(byobItem => {
    if (lastDiscountKey) byobItem.comparePrice = byobItem.price - byobItem.price * (discounts[lastDiscountKey] / 100);
    else delete byobItem.comparePrice;
  })

  addedBundleItems.forEach(byobItem => {
    const byobItemPriceContainer = document.querySelector(`[data-uniq-id="${byobItem.uniqId}"] .byob__item-price`);
    if (byobItemPriceContainer) {
      const oldComparePrice = byobItemPriceContainer.querySelector('.byob__item-price_sale');
      oldComparePrice && oldComparePrice.remove();

      if (byobItem.comparePrice) {
        byobItemPriceContainer.classList.add('has-compare');
        byobItemPriceContainer.innerHTML += `<div class="byob__item-price_sale">${moneyFormatHandler(byobItem.comparePrice)}</div>`
      } else {
        byobItemPriceContainer.classList.remove('has-compare');
      }
    }
  })
}

function removeBundleItemHandler(uniqIdValue) {
  const indexToRemove = addedBundleItems.findIndex(item => +uniqIdValue === item.uniqId);
  if (indexToRemove != -1) {
    addedBundleItems.splice(indexToRemove, 1);
    const removedBundleItem = document.querySelector(`[data-uniq-id="${uniqIdValue}"]`);
    removedBundleItem && removedBundleItem.remove();
  }
}

function submitButtonPriceHandler() {
  const submitButton = document.querySelector('.byob__widget-button');
  if (!submitButton) return;

  const buttonTextElement = submitButton.querySelector('span');
  if (!buttonTextElement) return;
  const defaultText = submitButton.dataset.text || 'Add to cart';
  // Calculate final price using reduce
  const finalPrice = (addedBundleItems && addedBundleItems.length > 0)
    ? addedBundleItems.reduce((total = 0, item) => {
      const price = Number(item.comparePrice ?? item.price);
      return total + +(price / 100).toFixed(2);
    }, 0)
    : 0;

  // Update button state and text
  if (finalPrice > 0) {
    submitButton.classList.remove('no-products');
    buttonTextElement.innerText = `${defaultText} ${productMoneySymbol}${finalPrice.toFixed(2)}`;
  } else {
    submitButton.classList.add('no-products');
    buttonTextElement.innerText = defaultText;
  }
}

let isLoad = false;
window.addEventListener('load', () => {
  isLoad = true;
})

function bundleItemsHandler(data, action, isLoadPage, isAjaxRender) {
  switch (action) {
    case 'ADD':
      const activePopup = document.querySelector('.variant-popup.active-popup');
      if (activePopup && isLoad && window.innerWidth <= 768) {
        setTimeout(() => {
          // A small transition before opening the main widget
          activePopup.querySelector('.close-popup').click();
          document.querySelector('.byob__widget-toggle').click();
        }, 500);
      }
      if (!isAjaxRender) addedBundleItems.push(data)
      break;
    case 'REMOVE':
      removeBundleItemHandler(data);

    default:
      break;
  }

  if (!isLoadPage) {
    setlocalStorageHandler();
    handleByobItemCount();
  }

  discountsHandler();
  submitButtonPriceHandler();
}

function bundleListHandler(data, isLoadPage, isAjaxRender) {
  const byobBundleList = document.querySelector('.byob__widget-list');
  let { id, image, price, productTitle, colorTitle, sizeTitle, uniqId: newUniqId } = data;
  let productTitleText = productTitle;

  if (colorTitle.length > 6) {
    colorTitle = `${colorTitle.substring(0, 6).trim()}...`;
  }

  const bundleItem = document.createElement('li');
  let uniqId = newUniqId ? newUniqId : Date.now();
  bundleItem.setAttribute('data-uniq-id', uniqId);
  bundleItem.setAttribute('data-origin-price', price);
  bundleItem.classList.add('byob__item');
  bundleItem.innerHTML = `
    <div class="byob__item-image">
      <img src="${image}" alt="${productTitle}" width="32" height="32" loading="lazy" />
    </div>
    <div class="byob__item-body">
      <div class="byob__item-info">
        <div class="byob__item-image-title">
          <div class="byob__item-image mobile">
            <img src="${image}" alt="${productTitleText}" width="32" height="32" loading="lazy" />
          </div>
          <h3 class="byob__item-title">
            <span>${productTitleText}</span>
          </h3>
        </div>
        <div class="byob__item-variant">
          <span>Colour <strong>${colorTitle}</strong></span>
          <span>Size <strong>${sizeTitle}</strong></span>
        </div>
      </div>
      <div class="byob__item-price">
        <div class="byob__item-price_regular">${moneyFormatHandler(price)}</div>
      </div>
    </div>
    <button class="byob__item-remove" data-uniq-id="${uniqId}">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.84819 3.66902C4.09227 3.42494 4.43625 3.37319 4.61649 3.55344L12.4491 11.386C12.6293 11.5662 12.5776 11.9102 12.3335 12.1543C12.0894 12.3984 11.7454 12.4501 11.5652 12.2699L3.73261 4.43732C3.55236 4.25708 3.60411 3.9131 3.84819 3.66902Z" fill="#2F2F2F"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.66743 12.1542C3.42336 11.9102 3.37161 11.5662 3.55185 11.386L11.3844 3.55338C11.5647 3.37314 11.9086 3.42489 12.1527 3.66897C12.3968 3.91305 12.4485 4.25703 12.2683 4.43727L4.43573 12.2698C4.25549 12.4501 3.91151 12.3983 3.66743 12.1542Z" fill="#2F2F2F"/>
      </svg>
    </button>
  `

  byobBundleList.appendChild(bundleItem);
  bundleItemsHandler({ id, image, price, productTitle, colorTitle, sizeTitle, uniqId }, 'ADD', isLoadPage, isAjaxRender);
}

function addToCartHandler() {
  const itemMap = {};

  for (const item of addedBundleItems) {
    const id = item.id;
    if (itemMap[id]) {
      itemMap[id].quantity += 1;
    } else {
      itemMap[id] = {
        id: id,
        quantity: 1,
        properties: {
          _byob_property: document.querySelector('.byob__widget').getAttribute('data-mini-cart-tag')
        }
      };
    }
  }

  const formData = {
    items: Object.values(itemMap),
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      return response.json();
    })
    .then(() => {
      document.querySelectorAll('.byob__item-remove').forEach(byobClose => byobClose.click());
      if (document.querySelector('.byob__widget.is--open')) {
        document.querySelector('.byob__widget-toggle').click();
        // We use setTimeout to open the Cart after the animation for BYOBWidget is complete
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }, 300);
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

//DWFT-4827 code goes here
function handleByobItemCount() {
  let byobData = localStorage.getItem('byob_items');

  if (byobData) {
    let byobItems = JSON.parse(byobData);
    let byobItemCount;

    if (Array.isArray(byobItems)) {
      byobItemCount = byobItems.length;
      progressbarMessageHandler(byobItemCount);
      progressBarHandler(byobItemCount);
    }
  }
}

function progressbarMessageHandler(itemCount) {
  const { byob_tier1_qty, byob_tier2_qty, byob_tier3_qty } = theme.settings;
  let count = itemCount;

  const messageContainer = document.querySelector('.byob-progressbar-message h3');

  function getTierMessage(count, tier1, tier2, tier3) {
    // checking out empty or undefined tiers
    const tiers = [tier1, tier2, tier3].filter(n => typeof n === 'number' && n > 0).sort((a, b) => a - b);

    if (count === 0 && tiers[0]) {
      let byob_empty_message_text = theme.settings.byob_empty_message_text;
      return byob_empty_message_text.replace(/<\/?p>/gi, '');
    }

    if (count < tiers[0]) {
      const nextTier = tiers[0];
      const x = nextTier - count;
      let byob_inprogress_msg = theme.settings.byob_inprogress_msg;
      byob_inprogress_msg = byob_inprogress_msg.replace("X", x);
      return byob_inprogress_msg.replace(/<\/?p>/gi, '');
    }

    if (count >= tiers[0] && count < (tiers[1] || Infinity)) {
      const nextTier = tiers[1];
      const x = nextTier - count;
      let byob_message_tier1_msg = theme.settings.byob_message_tier1_msg;
      const messageResult = tierMessageHandler(byob_message_tier1_msg);
      let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
      let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
      tier_message_part2 = tier_message_part2.replace("X", x);
      const styledPart1 = `<span class="tier-msg-partone">${tier_message_part1}</span>`;
      return styledPart1 + tier_message_part2;
    }

    if (tiers[1] && count >= tiers[1] && count < (tiers[2] || Infinity)) {
      const nextTier = tiers[2];
      const x = nextTier - count;
      let byob_message_tier2_msg = theme.settings.byob_message_tier2_msg;
      const messageResult = tierMessageHandler(byob_message_tier2_msg);
      let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
      let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
      tier_message_part2 = tier_message_part2.replace("X", x);
      const styledPart1 = `<span class="tier-msg-partone">${tier_message_part1}</span>`;
      return styledPart1 + tier_message_part2;
    }

    if (tiers[2] && count >= tiers[2]) {
      let byob_message_tier3_msg = theme.settings.byob_message_tier3_msg;
      const messageResult = tierMessageHandler(byob_message_tier3_msg);
      let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
      let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
      const styledPart1 = `<span class="tier-msg-partone">${tier_message_part1}</span>`;

      return styledPart1 + tier_message_part2;
    }

    return '';
  }

  const message = getTierMessage(count, byob_tier1_qty, byob_tier2_qty, byob_tier3_qty);

  if (messageContainer) {
    messageContainer.innerHTML = message;
  }
}

function progressBarHandler(itemCount) {
  const progressbarWrapper = document.getElementById('byob-bar-wrapper');
  progressbarWrapper.innerHTML = '';

  const {
    byob_tier1_qty,
    byob_tier2_qty,
    byob_tier3_qty,
    byob_tier1_discount,
    byob_tier2_discount,
    byob_tier3_discount
  } = theme.settings;

  const currentCount = itemCount;

  const barLength = Math.max(byob_tier1_qty, byob_tier2_qty, byob_tier3_qty);
  const tiers = [
    { qty: byob_tier1_qty, discount: byob_tier1_discount },
    { qty: byob_tier2_qty, discount: byob_tier2_discount },
    { qty: byob_tier3_qty, discount: byob_tier3_discount }
  ];

  for (let i = 1; i <= barLength; i++) {
    const barInnerWrap = document.createElement('div');
    barInnerWrap.className = 'byob-bar-inner-wrap';

    const percentageBar = document.createElement('div');
    percentageBar.className = 'percentage';

    const bar = document.createElement('div');
    bar.className = 'byob-bar';

    // Checking if it's tier bar
    const tier = tiers.find(t => t.qty === i);

    if (tier) {
      percentageBar.innerText = `${tier.discount}%`;

      if (i <= currentCount) {
        percentageBar.style.opacity = '1';
        bar.style.opacity = '1';
      } else {
        percentageBar.style.opacity = '0.3';
        bar.style.opacity = '0.3';
      }

      if (isTenaStore) {
        bar.style.background = '#003A81';
      } else {
        bar.style.background = '#d11788';
      }
    } else {
      percentageBar.innerHTML = '&nbsp;';

      if (i <= currentCount) {
        if (isTenaStore) {
          bar.style.backgroundColor = '#439EDD';
        } else {
          bar.style.backgroundColor = '#2e2e2e';
        }
        bar.style.opacity = '1';
      } else {
        if (isTenaStore) {
          bar.style.backgroundColor = '#D8D8D8';
        } else {
          bar.style.backgroundColor = '#d7d3d3';
        }
      }
    }

    barInnerWrap.appendChild(percentageBar);
    barInnerWrap.appendChild(bar);
    progressbarWrapper.appendChild(barInnerWrap);
  }
}

function tierMessageHandler(tierMessage) {
  let tier_msg_split = tierMessage.split("%");
  let tier_before_percent = tier_msg_split[0];

  let tier_after_percent = tierMessage
    .replace(tier_before_percent, '')
    .replace('%', '');

  let tier_space_split = tier_after_percent.trim().split(" ");
  let tier_first_word = tier_space_split[0]; // "Only"

  // first part of the message
  let tier_msg_part1 = tier_before_percent + "%" + tier_first_word + " ";

  // second part of the message
  let tier_msg_part2 = tierMessage.replace(tier_msg_part1, '');

  return {
    tier_msg_part1: tier_msg_part1,
    tier_msg_part2: tier_msg_part2
  };
}

// script for on select change in variant-popup for BYOB 
window.attachEventListeners2 = function (context = document) {
  const productCards = context.querySelectorAll('.product-card');

  productCards.forEach(card => {
    const productId = card.dataset.productCardId; // Get the product ID from the product card
    if (!productId) {
      console.warn('Product card missing data-product-card-id:', card);
      return; // Skip if no product ID
    }
    const variantSelector = card.querySelector('.variant-selector');
    const colorOptions = card.querySelector('.color-options');
    const sizeOptions = card.querySelector('.size-options');

    // Find the corresponding Add to Bundle button and its proxy
    const byobBtn = context.querySelector(`.byobbtn[data-byob-product-id="${productId}"]`);
    const byobBtnProxy = context.querySelector(`.proxy-byob-button[data-byob-proxy-product-id="${productId}"]`);

    // Ensure essential elements exist for this card
    if (!variantSelector || !colorOptions || !sizeOptions || !byobBtn || !byobBtnProxy) {
      console.warn(`Missing essential elements for product card ID ${productId}. Skipping event listeners.`, card);
      return;
    }

    const activecolorOptions = colorOptions.querySelector('label.variant__button-label');
    const activecolorPopuplabel = variantSelector.querySelector('.active-color');
    const variantPopupTitle = card.querySelector('.variant-title-popup.disabled');
    const variantPopupTitleDisabled = card.querySelector('.variant-title-popup.notdisabled');

    // Find the corresponding activeSizeInfoStrong and activeColorInfoStrong elements
    const activeSizeInfoStrong = context.querySelector(`.active-size-info[data-product-id="${productId}"] strong`);
    const activeSizeInfoStrongDesk = context.querySelector(`.active-size-info.desktop[data-product-id="${productId}"] strong`);
    const activeColorInfoStrong = context.querySelector(`.active-color-info[data-product-id="${productId}"] strong`);
    const activeColorInfoStrongMob = context.querySelector(`.active-color-wrapper.on-mobile  .active-color-info[data-product-id="${productId}"] strong`);
    const colorCircle = context.querySelector(`.active-color-info[data-product-id="${productId}"] .color-circle`);
    const colorCircleMob = context.querySelector(`.active-color-wrapper.on-mobile .active-color-info[data-product-id="${productId}"] .color-circle`);

    // Find the price element for this specific product card
    const priceElement = context.querySelector(`.grid-product__price[data-product-id="${productId}"] .grid-product__price--after`);

    const screenWidth = window.innerWidth;
    const productVariants = window.productVariantsData[productId];
    let selectedColor = '';
    let selectedSize = '';

    // Function to update size options based on selected color
    function updateSizeOptions(controlElement) {
      const color = controlElement.value;

      // Reset disabled state for all sizes
      sizeOptions.querySelectorAll('.variant-item').forEach(item => {
        const sizelabel = item.querySelector('.variant__button-label');
        const sizeInput = item.querySelector('input');
        sizelabel.classList.remove('disabled');
        sizeInput.disabled = false; // Ensure input is enabled by default
      });

      // Reset visual indicators
      if (activecolorOptions) activecolorOptions.classList.remove('disabled');
      if (colorCircle) colorCircle.classList.remove('disabled');
      if (colorCircleMob) colorCircleMob.classList.remove('disabled');
      if (screenWidth <= 768) {
        if (variantPopupTitle) variantPopupTitle.style.display = 'none';
        if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'none';
      }
      if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'none';
      if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'none';
      if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'none';
      if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'none';
      if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'none';

      selectedSize = ''; // Reset selected size
      clearButtonData(); // Clear button data attributes
      // Update active color display
      updateActiveColorDisplay(controlElement);

      if (color && productVariants) {
        const availableSizes = [];
        productVariants.forEach(variant => {
          if (variant.option1 === color && variant.available) {
            availableSizes.push(variant.option2);
          }
        });
        // Iterate through all size options and disable the ones that are not in availableSizes
        sizeOptions.querySelectorAll('.variant-item').forEach(item => {
          const size = item.querySelector('input').value;
          const sizelabel = item.querySelector('.variant__button-label');
          const sizeInput = item.querySelector('input');
          if (!availableSizes.includes(size)) {
            sizelabel.classList.add('disabled');
          }
        });

        // We need to run this script only after all the logic has been executed, so we use setTimeout
        setTimeout(() => {
          const selectedDisabledSize = sizeOptions.querySelector('input:checked + label.variant__button-label.disabled');
          if (selectedDisabledSize) {
            const input = selectedDisabledSize.previousElementSibling;
            if (input && input.classList.contains('size-radio')) {
              input.checked = false;
              selectedDisabledSize.click();
            }
          }
        }, 0);

        // Apply disabled visual states if no sizes are available for the selected color
        if (availableSizes.length === 0) {
          if (activecolorOptions) activecolorOptions.classList.add('disabled');
          if (screenWidth <= 768) {
            if (variantPopupTitle) variantPopupTitle.style.display = 'block';
            if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'none';
          }
          if (colorCircle) colorCircle.classList.add('disabled');
          if (colorCircleMob) colorCircleMob.classList.add('disabled');
          if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'line-through';
          if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'line-through';
          if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'line-through';
          if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'line-through';
          if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'line-through';
        }
        // Select the first available size that is currently checked, or the first available if none checked
        const currentCheckedSize = sizeOptions.querySelector('input[type="radio"]:checked');
        if (currentCheckedSize && availableSizes.includes(currentCheckedSize.value)) {
          selectedSize = currentCheckedSize.value;
          updateButtonData(color, selectedSize);
          updateActiveSizeDisplay(selectedSize);
        } else if (availableSizes.length > 0) {
          // If the previously selected size is not available, try to select the first available
          const firstAvailableSizeInput = sizeOptions.querySelector(`input[value="${availableSizes[0]}"]`);
          if (firstAvailableSizeInput) {
            firstAvailableSizeInput.checked = true; // Programmatically check it
            selectedSize = firstAvailableSizeInput.value;
            updateButtonData(color, selectedSize);
            updateActiveSizeDisplay(selectedSize);
          } else {
            clearButtonData();
            updateActiveSizeDisplay('');
          }
        } else {
          // No sizes available for this color
          clearButtonData();
          updateActiveSizeDisplay('');
        }
      } else {
        // No color selected or productVariants data missing
        clearButtonData();
        updateActiveSizeDisplay('');
      }
    }
    // Function to update the active color display
    function updateActiveColorDisplay(controlElement) {
      const color = controlElement.value;
      const activeColorNameSpans = card.querySelectorAll('.byob-active-color-name .active-color');

      activeColorNameSpans.forEach(span => {
        span.textContent = color;
      });

      if (activeColorInfoStrong) {
        activeColorInfoStrong.textContent = color;
      }

      if (activeColorInfoStrongMob) {
        activeColorInfoStrongMob.textContent = color;
      }
      if (colorCircle && controlElement && controlElement.nextElementSibling) {
        colorCircle.removeAttribute('style');

        // Get source inline styles from the label (next sibling of the radio input)
        const sourceStyles = controlElement.nextElementSibling.style;

        // Apply each inline style property to colorCircle
        for (let i = 0; i < sourceStyles.length; i++) {
          const propName = sourceStyles[i];
          colorCircle.style[propName] = sourceStyles.getPropertyValue(propName);
        }
      }
      if (colorCircleMob && controlElement && controlElement.nextElementSibling) {
        colorCircleMob.removeAttribute('style');

        // Get source inline styles from the label (next sibling of the radio input)
        const sourceStyles = controlElement.nextElementSibling.style;

        // Apply each inline style property to colorCircleMob
        for (let i = 0; i < sourceStyles.length; i++) {
          const propName = sourceStyles[i];
          colorCircleMob.style[propName] = sourceStyles.getPropertyValue(propName);
        }
      }
    }

    // Function to update the active size display
    function updateActiveSizeDisplay(size) {
      if (activeSizeInfoStrong) {
        activeSizeInfoStrong.textContent = size;
      }
      if (activeSizeInfoStrongDesk) { // Check for desktop version too
        activeSizeInfoStrongDesk.textContent = size;
      }
    }

    // Function to find the matching variant and update data attributes
    function updateButtonData(color, size) {
      let foundVariant = null;
      let isAvailable = false;
      let productVariants = window.productVariantsData[productId];

      if (!productVariants) {
        console.warn(`productVariantsData not found for product ID ${productId}`);
        clearButtonData();
        return;
      }

      productVariants.forEach(variant => {
        if (variant.option1 === color && variant.option2 === size) {
          foundVariant = variant;
          isAvailable = variant.available;
          return; // Exit the loop once a match is found
        }
      });

      if (foundVariant && isAvailable) {
        byobBtn.dataset.variantId = foundVariant.id;
        byobBtn.dataset.price = foundVariant.price;
        byobBtn.dataset.colorName = color;
        byobBtn.dataset.sizeName = size;
        byobBtn.dataset.variantImage = foundVariant.featured_image?.src || ''; // Use optional chaining for image src
        productUrlHandler(true, foundVariant.id);

        byobBtn.classList.remove('disabled');
        byobBtn.disabled = false;
        byobBtnProxy.classList.remove('disabled');
        byobBtnProxy.disabled = false;

        let activecolorOptionsOld = colorOptions.querySelector('label.variant__button-label.disabled');
        activecolorOptionsOld && activecolorOptionsOld.classList.remove('disabled');
        // Visual feedback for active/available state
        if (activecolorOptions) activecolorOptions.classList.remove('disabled');
        if (colorCircle) colorCircle.classList.remove('disabled');
        if (colorCircleMob) colorCircleMob.classList.remove('disabled');
        if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'none';
        if (screenWidth <= 768) {
          if (variantPopupTitle) variantPopupTitle.style.display = 'none';
          if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'block';
        }
        if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'none';
        if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'none';
        if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'none';
        if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'none';
        // --- PRICE UPDATE LOGIC ---
        if (priceElement) {
          const formattedPrice = (foundVariant.price / 100).toFixed(2);
          priceElement.textContent = `£${formattedPrice}`; // Update with your currency symbol
        }
        // --- END PRICE UPDATE LOGIC ---

      } else {
        // No matching variant found or variant is OOS
        clearButtonData();

        if (foundVariant && foundVariant.id) {
          productUrlHandler(true, foundVariant.id);
        } else {
          productUrlHandler(false);
        }

        let activecolorOptionsOld = colorOptions.querySelector('label.variant__button-label.disabled');
        activecolorOptionsOld && activecolorOptionsOld.classList.remove('disabled');
        let newActiveColorOptions = colorOptions.querySelector('input:checked + label.variant__button-label')

        // Visual feedback for disabled/unavailable state
        if (activeSizeInfoStrongDesk) activeSizeInfoStrongDesk.style.textDecoration = 'line-through';
        if (activeSizeInfoStrong) activeSizeInfoStrong.style.textDecoration = 'line-through';
        if (activeColorInfoStrong) activeColorInfoStrong.style.textDecoration = 'line-through';
        if (activeColorInfoStrongMob) activeColorInfoStrongMob.style.textDecoration = 'line-through';
        if (newActiveColorOptions) newActiveColorOptions.classList.add('disabled');
        if (screenWidth <= 768) {
          if (variantPopupTitle) variantPopupTitle.style.display = 'block';
          if (variantPopupTitleDisabled) variantPopupTitleDisabled.style.display = 'none';
        }
        if (colorCircle) colorCircle.classList.add('disabled');
        if (colorCircleMob) colorCircleMob.classList.add('disabled');
        if (activecolorPopuplabel) activecolorPopuplabel.style.textDecoration = 'line-through';
      }
    }

    // Function to clear the button's data attributes and disable it
    function clearButtonData() {
      byobBtn.dataset.variantId = '';
      byobBtn.dataset.price = '';
      byobBtn.dataset.colorName = '';
      byobBtn.dataset.sizeName = '';
      byobBtn.dataset.variantImage = '';
      byobBtn.classList.add('disabled');
      byobBtn.disabled = true;
      byobBtnProxy.classList.add('disabled');
      byobBtnProxy.disabled = true;
    }

    function productUrlHandler(isVariant, variantId) {
      const mainProductCard = card.closest('.grid__item.grid-product');
      if (mainProductCard) {
        const productLinks = mainProductCard.querySelectorAll('.byob-link');
        productLinks.forEach(link => {
          isVariant ?
            link.setAttribute('href', `${link.dataset.productUrl}?variant=${variantId}`) :
            link.setAttribute('href', link.dataset.productUrl)
        })
      }
    }

    // --- Event Listeners ---
    // Remove existing listeners to prevent duplicates if attachEventListeners2 is called multiple times
    // (e.g., due to AJAX pagination)
    colorOptions.removeEventListener('change', colorChangeHandler);
    sizeOptions.removeEventListener('change', sizeChangeHandler);
    byobBtn.removeEventListener('click', byobClickHandler);

    // Add new listeners
    colorOptions.addEventListener('change', colorChangeHandler);
    sizeOptions.addEventListener('change', sizeChangeHandler);
    byobBtn.addEventListener('click', byobClickHandler);

    function colorChangeHandler(event) {
      if (event.target.classList.contains('color-radio')) {
        selectedColor = event.target.value;
        updateSizeOptions(event.target);
      }
    }

    function sizeChangeHandler(event) {
      if (event.target.classList.contains('size-radio')) {
        selectedSize = event.target.value;
        if (selectedColor && selectedSize) {
          updateButtonData(selectedColor, selectedSize);
          updateActiveSizeDisplay(selectedSize);
        } else {
          clearButtonData();
          updateActiveSizeDisplay('');
        }
      }
    }

    function byobClickHandler(event) {
      if (this.classList.contains('disabled')) {
        event.preventDefault();
        event.stopImmediatePropagation(); // Prevent other click handlers from running
        return;
      }
      // Your add to cart logic here (if you have any)
      // This button will now have the correct variant ID, price, etc. in its data attributes
    }

    // --- Initialization ---
    // Initialize button state based on currently selected (checked) radios
    const initialColorRadio = colorOptions.querySelector('.color-radio:checked');
    if (initialColorRadio) {
      selectedColor = initialColorRadio.value;
      updateSizeOptions(initialColorRadio); // This will also trigger size selection and button data update
    } else {
      clearButtonData(); // No initial color selected, disable button
    }
  });
};

// --- DOMContentLoaded Listener ---
// This ensures the function runs once the DOM is fully loaded.
// If your theme uses AJAX for pagination, you'll need to re-call
// window.attachEventListeners2() after new product cards are loaded.
document.addEventListener('DOMContentLoaded', function () {
  window.attachEventListeners2();
});